import React from 'react';
import {Route} from 'react-router-dom';

function CustomRoute(props) {
    var Component = props.component;
    return (<Route exact={props.exact} path={props.path} render={(routerProps)=>
        <Component {...routerProps} {...props} />
    } />)
}

export default CustomRoute;